import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { Card } from "@/components/ui/card";

export default function Admin() {
  return (
    <div data-testid="admin-page">
      <PageHeader
        title="Administration"
        subtitle="Users, roles, departments and system configuration."
      />

      <Card className="hr-card p-5 mb-6">
        <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Roles in this workspace</div>
        <div className="flex flex-wrap gap-2">
          {["super_admin", "hr", "recruiter", "manager", "employee", "it", "finance"].map((r) => (
            <span key={r} className="px-2.5 py-1 rounded-full bg-[#F26B3A]/5 text-[#0F172A] text-xs font-medium capitalize">
              {r.replace("_", " ")}
            </span>
          ))}
        </div>
      </Card>

      <DataTable
        testId="users-table"
        endpoint="/users"
        columns={[
          { key: "name", label: "Name" },
          { key: "email", label: "Email", mono: true },
          { key: "employee_id", label: "Employee ID", mono: true },
          { key: "role", label: "Role", render: (r) => <span className="capitalize">{r.role?.replace("_"," ")}</span> },
          { key: "active", label: "Active", render: (r) => r.active ? "Yes" : "No" },
        ]}
      />

      <div className="mt-6">
        <DataTable
          testId="departments-table"
          endpoint="/departments"
          columns={[
            { key: "name", label: "Department" },
            { key: "head", label: "Head" },
            { key: "headcount", label: "Headcount", align: "right" },
          ]}
        />
      </div>
    </div>
  );
}
